const getFirstErrorPath = (value: unknown, path = ''): string | null => {
  if (typeof value === 'string') return value.trim() ? path || null : null;

  if (Array.isArray(value)) {
    for (let index = 0; index < value.length; index += 1) {
      const errorPath = getFirstErrorPath(value[index], `${path}[${index}]`);
      if (errorPath) return errorPath;
    }
    return null;
  }

  if (value && typeof value === 'object') {
    for (const [key, nestedValue] of Object.entries(value)) {
      const errorPath = getFirstErrorPath(nestedValue, path ? `${path}.${key}` : key);
      if (errorPath) return errorPath;
    }
  }

  return null;
};

const escapeAttributeValue = (value: string) => value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

const getFieldNameVariants = (path: string) => [
  path,
  path.replace(/\[(\d+)\]/g, '.$1'),
  path.replace(/\.(\d+)(?=\.|$)/g, '[$1]'),
];

export const scrollToFormikError = (errors: object) => {
  const errorPath = getFirstErrorPath(errors);
  if (!errorPath) return;

  requestAnimationFrame(() => {
    const field =
      document.getElementById(errorPath) ||
      getFieldNameVariants(errorPath)
        .map(name => document.querySelector<HTMLElement>(`[name="${escapeAttributeValue(name)}"]`))
        .find(Boolean);

    if (!field) return;

    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
    field.focus({ preventScroll: true });
  });
};

export const hasFormikErrors = (errors: object) => Boolean(getFirstErrorPath(errors));
